/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'icons/arrow-down': {
    width: 16,
    height: 16,
    viewBox: '0 0 28 16.36',
    data: '<g data-name="Layer 2"><g data-name="Layer 1"><path pid="0" d="M11 13.5L25 0l3 2.86-14 13.5z"/><path pid="1" d="M14 16.36L0 2.86 3 0l14 13.5z"/></g></g>'
  }
})
